import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { IIceCatReportMaterialNumberRequest } from '../models/models'

export class GetIceCatReportMaterialNumberApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/icecat/GetIceCatReportMaterialNumber',
      requesterInfo,
    })
  }

  public async getIceCatReportMaterialNumber(request: IIceCatReportMaterialNumberRequest): Promise<any[]> {
    return await this.postAsync<any[]>(request)
  }
}
